export enum OrganizationStatusEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum BillingPlanEnum {
  FREE = 'FREE',
  GROWTH = 'GROWTH',
  STARTER = 'STARTER',
  SCALE = 'SCALE',
  PREMIUM = 'PREMIUM',
}

export enum BillingPresetEnum {
  NONE = 'NONE',
  PREMIUM = 'PREMIUM',
}

export type Organization = {
  id: string;
  external_id: string;
  name: string;
  status: OrganizationStatusEnum;
  billing_plan: BillingPlanEnum;
  /** Absent on older API payloads until Admin GET always includes the fields. */
  billing_preset?: BillingPresetEnum;
  billing_preset_price?: number | null;
  billing_preset_price_locked_at?: string | null;
  is_test: boolean;
  disable_emails: boolean;
  customer_id: string | null;
  subscription_id: string | null;
  internal_use: boolean | null;
  /** Set once an archive is queued behind a scheduled Free downgrade. Absent until the backend ships it. */
  // TODO(CP-6082): the admin organization response does not return this yet; the archive banner stays hidden until it does.
  pending_archive_at?: string | null;
};

export type OrganizationUser = {
  user_id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  user_role: string | null;
  enabled: boolean;
};
